/**
 * pdp.js — Clean 2.0 PDP shared scripts
 * Handles: tab switching, gallery thumbnails, Swiper init, FBT ATC, variant price sync
 */

(function () {
  'use strict';

  /* ===== Tab switching ===== */
  document.addEventListener('DOMContentLoaded', function () {
    var tabBtns = document.querySelectorAll('[data-tab]');
    var tabPanels = document.querySelectorAll('[data-panel]');

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        // Testimonials scrolls to the reviews section rather than showing a panel
        if (target === 'testimonials') {
          var reviews = document.getElementById('reviews-bottom');
          if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        tabBtns.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(function (p) {
          p.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        var panel = document.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    /* Smooth scroll back-to-top links */
    document.querySelectorAll('.back-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var anchor = document.getElementById('tabs-anchor');
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  });


  /* ===== Media gallery thumbnail switching + arrow scroll ===== */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = this.getAttribute('data-media-id');
        var gallery = this.closest('[data-pdp-gallery]');
        if (!gallery) return;

        // Toggle active via class (CSS opacity) — NOT hidden attribute, because
        // collapsing the non-active slides to 0 causes a page jump.
        gallery.querySelectorAll('.pdp-gallery__media').forEach(function (el) {
          el.classList.toggle('pdp-gallery__media--active', el.getAttribute('data-media-id') === mediaId);
        });

        gallery.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
          t.classList.toggle('pdp-gallery__thumb--active', t === thumb);
        });
      });
    });

    // Arrow buttons scroll the thumbnail strip by ~one visible page.
    // The rail is horizontal below 1400px and vertical at >=1400px, so each
    // helper picks the right axis at call time (handles window resizing too).
    var verticalQuery = window.matchMedia('(min-width: 1400px)');
    document.querySelectorAll('.pdp-gallery__thumbs-wrap').forEach(function (wrap) {
      var track = wrap.querySelector('[data-pdp-thumbs]');
      var prev = wrap.querySelector('[data-pdp-thumbs-prev]');
      var next = wrap.querySelector('[data-pdp-thumbs-next]');
      if (!track || !prev || !next) return;

      function isVertical() { return verticalQuery.matches; }
      function pos() { return isVertical() ? track.scrollTop : track.scrollLeft; }
      function maxScroll() {
        return isVertical()
          ? track.scrollHeight - track.clientHeight - 1
          : track.scrollWidth - track.clientWidth - 1;
      }
      function step() {
        var dim = isVertical() ? track.clientHeight : track.clientWidth;
        return Math.max(120, Math.floor(dim * 0.9));
      }
      function scrollByDelta(delta) {
        track.scrollBy(isVertical()
          ? { top: delta, behavior: 'smooth' }
          : { left: delta, behavior: 'smooth' });
      }
      function updateDisabled() {
        prev.disabled = pos() <= 0;
        next.disabled = pos() >= maxScroll();
      }

      prev.addEventListener('click', function () { scrollByDelta(-step()); });
      next.addEventListener('click', function () { scrollByDelta(step()); });
      track.addEventListener('scroll', updateDisabled, { passive: true });
      window.addEventListener('resize', updateDisabled, { passive: true });
      updateDisabled();
    });
  });


  /* ===== Swiper initialization ===== */
  document.addEventListener('DOMContentLoaded', function () {
    function initSwipers() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initSwipers, 200);
        return;
      }

      /* Testimonials — 1 on mobile, 3 on desktop */
      if (document.querySelector('.testi-swiper')) {
        new Swiper('.testi-swiper', {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          pagination: { el: '.testi-dots', clickable: true },
          breakpoints: { 750: { slidesPerView: 3, spaceBetween: 20 } }
        });
      }

      /* Before/After carousel */
      if (document.querySelector('.ba-swiper')) {
        new Swiper('.ba-swiper', {
          slidesPerView: 1.15,
          spaceBetween: 15,
          navigation: {
            nextEl: '.ba-swiper .swiper-button-next',
            prevEl: '.ba-swiper .swiper-button-prev'
          },
          breakpoints: { 750: { slidesPerView: 2, spaceBetween: 20 } }
        });
      }

      /* FBT — on mobile, show 1.2 slides so the next card peeks and invites a swipe.
         Desktop shows all 3 in a row (no peek needed).
         slidesOffsetBefore aligns the first card with the pagewidth content
         edge (5% of viewport) on mobile — Swiper's official API for this,
         used as a backup since Swiper's bundled CSS sometimes wins specificity
         battles against our margin/padding overrides on .fbt-swiper. */
      if (document.querySelector('.fbt-swiper')) {
        var fbtOffset = window.matchMedia('(max-width: 749px)').matches
          ? Math.round(window.innerWidth * 0.05)
          : 0;
        new Swiper('.fbt-swiper', {
          slidesPerView: 1.2,
          spaceBetween: 12,
          centeredSlides: false,
          loop: false,
          slidesOffsetBefore: fbtOffset,
          pagination: { el: '.fbt-dots', clickable: true },
          breakpoints: { 750: { slidesPerView: 4, spaceBetween: 20, centeredSlides: false, slidesOffsetBefore: 0 } }
        });
      }
    }

    initSwipers();
  });


  /* ===== FBT Add to Cart ===== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pdp-fbt-atc]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.textContent = 'ADDING\u2026';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'ADDED \u2713';
        setTimeout(function () {
          btn.textContent = 'ADD TO CART';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'ADD TO CART';
        btn.disabled = false;
      });
  });


  /* ===== Variant price sync ===== */
  document.addEventListener('DOMContentLoaded', function () {
    var priceEls = document.querySelectorAll('[data-pdp-price]');
    var compareEls = document.querySelectorAll('[data-compare-price]');
    var saveBadgeEls = document.querySelectorAll('[data-save-badge]');
    if (!priceEls.length) return;

    var productSelectEl = document.querySelector('[id^="ProductSelect-"]');
    var productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!productSelectEl || !productJsonEl) return;

    var productData;
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    function getCurrentVariant() {
      var variantId = parseInt(productSelectEl.value, 10);
      if (!variantId) return null;
      return productData.variants.find(function (v) { return v.id === variantId; }) || null;
    }

    function updatePrice() {
      var variant = getCurrentVariant();
      if (!variant) return;

      /* Idempotent writes: skip mutating textContent / style when the value
         already matches. Without these guards the 500ms polling interval
         below rewrites every price span twice a second whether anything
         changed or not, which makes the elements flash continuously in the
         devtools inspector. */
      var formatted = '$' + (variant.price / 100).toFixed(2);
      priceEls.forEach(function (el) {
        if (el.textContent !== formatted) el.textContent = formatted;
      });

      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEls.forEach(function (el) {
        if (hasCompare) {
          var compareText = '$' + (variant.compare_at_price / 100).toFixed(2);
          if (el.textContent !== compareText) el.textContent = compareText;
          if (el.style.display === 'none') el.style.display = '';
        } else if (el.style.display !== 'none') {
          el.style.display = 'none';
        }
      });

      saveBadgeEls.forEach(function (el) {
        if (hasCompare) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          var label = 'SAVE ' + pct + '%';
          if (el.textContent !== label) el.textContent = label;
          if (el.style.display === 'none') el.style.display = '';
        } else if (el.style.display !== 'none') {
          el.style.display = 'none';
        }
      });

      /* Loop widget prices — Loop sometimes updates these on variant change,
         sometimes doesn't. We own the sync here to guarantee consistency. */
      var loopPrice = document.getElementById('loop-price-one-time');
      var loopOriginal = document.getElementById('loop-price-one-time-original');
      if (loopPrice) {
        var loopFormatted = '$' + (variant.price / 100).toFixed(2);
        if (loopPrice.textContent !== loopFormatted) loopPrice.textContent = loopFormatted;
      }
      if (loopOriginal) {
        if (hasCompare) {
          var loopCompare = '$' + (variant.compare_at_price / 100).toFixed(2);
          if (loopOriginal.textContent !== loopCompare) loopOriginal.textContent = loopCompare;
          if (loopOriginal.style.display === 'none') loopOriginal.style.display = '';
        } else if (loopOriginal.style.display !== 'none') {
          loopOriginal.style.display = 'none';
        }
      }
    }

    /* Swap the gallery's active main image + active thumb to match the
       variant's featured media. Only acts when the variant actually changes —
       otherwise the 500ms poll would override a user's manual thumb click
       within half a second. */
    var lastAppliedVariantId = null;
    function updateMedia() {
      var variant = getCurrentVariant();
      if (!variant || !variant.featured_media) return;
      if (variant.id === lastAppliedVariantId) return;
      lastAppliedVariantId = variant.id;

      var mediaId = String(variant.featured_media.id);
      var gallery = document.querySelector('[data-pdp-gallery]');
      if (!gallery) return;

      gallery.querySelectorAll('.pdp-gallery__media').forEach(function (el) {
        el.classList.toggle('pdp-gallery__media--active', el.getAttribute('data-media-id') === mediaId);
      });
      gallery.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.classList.toggle('pdp-gallery__thumb--active', t.getAttribute('data-media-id') === mediaId);
      });
    }

    function syncFromVariant() {
      updatePrice();
      updateMedia();
    }

    /* The visible dropdown(s) carry option *text* values (e.g. "4oz
       Starter Bottle"); the hidden `<select name="id">` master is what
       gets posted to /cart/add. Without this glue, picking a different
       option only updates the visible UI — the form keeps submitting
       the original variant ID, the URL never updates, and price/media
       sync (which reads the master) never sees a change.

       On any visible-selector change, gather the selected option1/2/3
       values, find the matching variant, push its ID into the master
       select, dispatch a change event so the rest of the chain fires,
       and reflect ?variant= in the URL. */
    var optionSelects = document.querySelectorAll('.single-option-selector');
    function syncMasterFromOptions() {
      if (!optionSelects.length) return;
      var selectedValues = {};
      optionSelects.forEach(function (sel) {
        selectedValues[sel.getAttribute('data-index')] = sel.value;
      });
      var match = productData.variants.find(function (v) {
        return (
          (selectedValues.option1 == null || v.option1 === selectedValues.option1) &&
          (selectedValues.option2 == null || v.option2 === selectedValues.option2) &&
          (selectedValues.option3 == null || v.option3 === selectedValues.option3)
        );
      });
      if (!match) return;
      if (productSelectEl.value === String(match.id)) return;
      productSelectEl.value = String(match.id);
      productSelectEl.dispatchEvent(new Event('change', { bubbles: true }));
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* SecurityError on some sandboxed contexts — ignore */ }
      }
    }
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', syncMasterFromOptions);
    });

    productSelectEl.addEventListener('change', syncFromVariant);

    syncFromVariant();
    /* Poll as fallback for Loop/Smartrr async variant updates */
    setInterval(syncFromVariant, 500);
  });

}());
